/**
 * Normalize order field from API (camelCase or PascalCase).
 */
function pick(order, camel, pascal) {
    const v = order?.[camel];
    if (v !== undefined && v !== null && v !== '') return v;
    const v2 = order?.[pascal];
    if (v2 !== undefined && v2 !== null && v2 !== '') return v2;
    return '';
}

/**
 * Shipping address as one line per logical part (street, city, state, postal, country, phone).
 * Omits empty parts.
 */
export function getShippingAddressLines(order) {
    if (!order) return [];
    const first = pick(order, 'shippingFirstName', 'ShippingFirstName');
    const last = pick(order, 'shippingLastName', 'ShippingLastName');
    const street = pick(order, 'shippingAddress', 'ShippingAddress');
    const city = pick(order, 'shippingCity', 'ShippingCity');
    const state = pick(order, 'shippingState', 'ShippingState');
    const postal = pick(order, 'shippingPostalCode', 'ShippingPostalCode');
    const country = pick(order, 'shippingCountry', 'ShippingCountry');
    const phone = pick(order, 'shippingPhone', 'ShippingPhone');

    const lines = [];
    const name = [first, last].filter(Boolean).join(' ').trim();
    if (name) lines.push({ label: 'Name', value: name });
    if (street) lines.push({ label: 'Address', value: street });
    if (city) lines.push({ label: 'City', value: city });
    if (state) lines.push({ label: 'State / Province', value: state });
    if (postal) lines.push({ label: 'Postal code', value: postal });
    if (country) lines.push({ label: 'Country', value: country });
    if (phone) lines.push({ label: 'Phone', value: phone });
    return lines;
}

/** Account customer (logged-in) from nested customer object */
export function getAccountCustomer(order) {
    const c = order?.customer ?? order?.Customer;
    if (!c) return null;
    return {
        firstName: c.firstName ?? c.FirstName ?? '',
        lastName: c.lastName ?? c.LastName ?? '',
        email: c.email ?? c.Email ?? '',
        phone: c.phone ?? c.Phone ?? '',
    };
}
